<template>
    <div class="rounded-xl border border-border pl-4 md:pl-10 bg-surface-raised">
        <div class="grid md:grid-cols-[3fr_2fr] gap-x-10">
            <div class="sticky top-0 bg-surface-raised body-small text-ink-muted py-4 md:border-r rounded-t-xl md:rounded-none">
                {{ t("chat.rolePlaySummary.tips.transcript") }}
            </div>
            <div class="sticky top-0 bg-surface-raised body-small text-ink-muted py-4 rounded-tr-xl hidden md:block">{{ t("chat.rolePlaySummary.tips.feedback") }}</div>
            <template v-for="(message, index) in rolePlayMessages" :key="message.id">
                <div class="md:border-r py-4 pr-4" :class="{ 'text-right': message.role === 'user', 'pb-10': rolePlayMessages.length - 1 === index }">
                    <div :class="['w-4/5', message.role === 'user' ? 'ml-auto body-small' : 'mr-auto nadia-chat']">
                        <MarkdownText :custom-renderer="customRenderer" :text="getContentFromLines(message.lines)"></MarkdownText>
                    </div>
                </div>
                <div class="md:py-4 md:mr-0 md:pl-0 md:pr-10">
                    <TipsFeedback
                        v-if="isRolePlayMessage(message)"
                        v-bind="getRolePlayFeedback(message)"
                        class="border md:border-0 rounded-xl ml-auto w-4/5 md:w-full p-4 md:p-0 mr-4 md:mr-0 mb-2 md:mb-0" />
                </div>
            </template>
        </div>
    </div>
</template>

<script setup>
import { getRolePlayMonitorParams, isRolePlayMessage } from "~vue/chatActions";
import MarkdownText from "~vue/MarkdownText.vue";
import { useI18n } from "vue-i18n";

import TipsFeedback from "./TipsFeedback.vue";

const { rolePlayMessages } = defineProps({
    rolePlayMessages: { type: Array, required: true },
});

const { t } = useI18n();

const getContentFromLines = (lines) => {
    return lines
        .filter((line) => line.type === "md" && !!line.content)
        .map((line) => line.content)
        .join("\n");
};

const getRolePlayFeedback = (message) => {
    const params = getRolePlayMonitorParams(message);
    return params ?? "";
};

// used to hide horizontal lines that are returned as markdown in roleplay
const customRenderer = {
    hr: () => "",
};
</script>
